import ModuleSevenReflection from "../../../../src/components/forms/ModuleSevenReflection";
import * as React from 'react';
export default {
  ModuleSevenReflection,
  React
};